import { Link, useLocation } from "react-router-dom";
import { Store, LogOut, Package, ClipboardList, Settings, BarChart3, Users } from "lucide-react";
import { useAdmin } from "@/context/AdminContext";

const AdminTopBar = () => {
  const { logout } = useAdmin();
  const { pathname } = useLocation();

  const tab = (to, label, Icon, testid) => {
    const active = pathname === to;
    return (
      <Link
        to={to}
        className={`flex items-center gap-1.5 text-sm font-medium px-3 h-9 rounded-sm transition-colors ${
          active ? "bg-[#1e293b] text-white" : "text-[#475569] hover:bg-slate-100"
        }`}
        data-testid={testid}
      >
        <Icon className="w-4 h-4" /> {label}
      </Link>
    );
  };

  return (
    <div className="bg-white border-b border-[#e2e8f0] sticky top-0 z-40" data-testid="admin-header">
      <div className="max-w-[1400px] mx-auto px-4 h-14 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Link to="/admin/products" className="flex items-center gap-2">
            <span className="bg-[#0f172a] text-white text-xs font-bold px-2.5 py-1 rounded-sm">BC</span>
            <span className="font-head font-bold text-[#0f172a] hidden sm:inline">BharatiCrafts Admin</span>
          </Link>
          <nav className="flex items-center gap-1">
            {tab("/admin/products", "Products", Package, "admin-nav-products")}
            {tab("/admin/orders", "Orders", ClipboardList, "admin-nav-orders")}
            {tab("/admin/customers", "Customers", Users, "admin-nav-customers")}
            {tab("/admin/analytics", "Analytics", BarChart3, "admin-nav-analytics")}
            {tab("/admin/settings", "Settings", Settings, "admin-nav-settings")}
          </nav>
        </div>
        <div className="flex items-center gap-2">
          <Link
            to="/"
            className="flex items-center gap-1.5 text-sm font-medium text-[#C62828] border border-[#C62828]/30 px-3 h-9 rounded-sm hover:bg-[#FCEBEA]"
            data-testid="admin-view-storefront-button"
          >
            <Store className="w-4 h-4" /> <span className="hidden sm:inline">View Store</span>
          </Link>
          <button
            onClick={logout}
            className="flex items-center gap-1.5 text-sm font-medium text-[#ef4444] border border-[#ef4444]/30 px-3 h-9 rounded-sm hover:bg-red-50"
            data-testid="admin-logout-button"
          >
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminTopBar;
